module.exports = __webpack_public_path__ + "img/bin-c-2.d87724c1.svg";